'use client';

import { useSyncExternalStore } from 'react';

/**
 * The viewer's clock — `null` on the server, the browser's time on the client.
 *
 * A competition's countdown is the only thing on these surfaces that depends on
 * "now", and rendering server time into the markup makes it disagree with the
 * client's first paint. The clock is read once, on the first client render, and
 * stays fixed afterwards: `Countdown` re-bases from `performance.now()`, so a
 * stable baseline is all it needs.
 */
export function useClientNowMs() {
  return useSyncExternalStore(subscribe, clientSnapshot, serverSnapshot);
}

/** The clock never changes on its own, so there is nothing to subscribe to. */
function subscribe(): () => void {
  return () => {};
}
let firstReadMs: number | null = null;
function clientSnapshot(): number {
  firstReadMs ??= Date.now();
  return firstReadMs;
}
function serverSnapshot(): null {
  return null;
}